module.exports = __webpack_public_path__ + "img/bandera.a1ce25ea.webp";